export function searchSegmentById(segments, segmentId) {
	if (!segments) {
		return undefined
	}

	let segment = segments?.find((s) => s.id === segmentId)
	if (segment) {
		return segment
	}

	for (const child of segments) {
		segment = searchSegmentById(child.children, segmentId)
		if (segment) {
			break
		}
	}

	return segment
}

export function getRosterMinSizeFromSegment(segment) {
	const rosterMinSize = segment?.configuration?.rosterMinSize
	if (!rosterMinSize) throw new Error('Missing rosterMinSize in segment configuration')
	return rosterMinSize
}

export function getRosterMaxSizeFromSegment(segment) {
	const rosterMaxSize = segment?.configuration?.rosterMaxSize
	if (!rosterMaxSize) throw new Error('Missing rosterMaxSize in segment configuration')
	return rosterMaxSize
}
